import { render, staticRenderFns } from "./AISetting.vue?vue&type=template&id=72835a78&scoped=true&"
import script from "./AISetting.vue?vue&type=script&lang=js&"
export * from "./AISetting.vue?vue&type=script&lang=js&"
import style0 from "./AISetting.vue?vue&type=style&index=0&id=72835a78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72835a78",
  null
  
)

export default component.exports